import {Box, Button} from "@mantine/core";
import {IconSquareArrowLeft, IconSquareArrowRight} from "@tabler/icons-react";
import cx from "clsx";
import classes from "../FocusModeView.module.css";

interface FocusModeNavigationProps {
    hasPrev: boolean;
    stepName: string;
    nextButtonText: string;
    nextButtonDisabled: boolean;
    showSkipAll: boolean;
    onPrev: () => void;
    onNext: () => void;
    onSkipAll: () => void;
}

/**
 * Navigation bar with prev/next buttons and optional skip-all for groups.
 */
export const FocusModeNavigation: React.FC<FocusModeNavigationProps> = ({
    hasPrev,
    stepName,
    nextButtonText,
    nextButtonDisabled,
    showSkipAll,
    onPrev,
    onNext,
    onSkipAll,
}) => {
    return (
        <Box className={cx(classes.focusModeBar)}>
            {hasPrev ? (
                <Button
                    className={cx(classes.navButton)}
                    size="xs"
                    leftSection={<IconSquareArrowLeft/>}
                    onClick={onPrev}
                >
                    Prev
                </Button>
            ) : (
                <Box/>
            )}

            <Box style={{justifySelf: "center"}}>
                {stepName}
            </Box>

            {showSkipAll && (
                <Button
                    className={cx(classes.navButton)}
                    variant="transparent"
                    size="xs"
                    onClick={onSkipAll}
                >
                    Skip All
                </Button>
            )}

            <Button
                className={cx(classes.navButton)}
                disabled={nextButtonDisabled}
                rightSection={<IconSquareArrowRight/>}
                onClick={onNext}
            >
                {nextButtonText}
            </Button>
        </Box>
    );
};
